module.exports = __webpack_public_path__ + "assets/img/solar-panels-8-small.5af551fd.jpg";